import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const TechnicalSupport = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Technical Support</h1>
            <p className="service-description">
              Round-the-clock technical support to resolve your IT issues quickly 
              and keep your business operations running smoothly.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Support Services</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">🌐</div>
                    <h3>Remote Support</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="Remote Support details">
                    <div className="popover-title">Remote Support includes</div>
                    <ul className="popover-list">
                      <li>Secure remote session setup</li>
                      <li>OS and application troubleshooting</li>
                      <li>Network and VPN assistance</li>
                      <li>Printer and device configuration</li>
                      <li>Patch and update guidance</li>
                      <li>How‑to and user assistance</li>
                    </ul>
                  </div>
                  <p>Instant assistance to resolve issues quickly without on‑site visits.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">📞</div>
                    <h3>8 X 6 Helpdesk</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="8 x 6 Helpdesk details">
                    <div className="popover-title">8 x 6 Helpdesk provides</div>
                    <ul className="popover-list">
                      <li>Phone, email, and chat support</li>
                      <li>Ticket creation and tracking</li>
                      <li>Standard SLAs and response targets</li>
                      <li>Knowledge base and self‑service</li>
                      <li>First‑call resolution focus</li>
                      <li>Daily status and summaries</li>
                    </ul>
                  </div>
                  <p>Responsive support window to keep your team productive.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">🛠️</div>
                    <h3>On-Site Support</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="On-Site Support details">
                    <div className="popover-title">On‑Site Support covers</div>
                    <ul className="popover-list">
                      <li>Hardware diagnostics and replacement</li>
                      <li>New device setup and installation</li>
                      <li>Network cabling and configuration</li>
                      <li>Critical incident hands‑on response</li>
                      <li>Vendor coordination on premises</li>
                      <li>Post‑fix verification</li>
                    </ul>
                  </div>
                  <p>Technician visit for issues requiring physical intervention.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">📈</div>
                    <h3>Issue Escalation</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="Issue Escalation details">
                    <div className="popover-title">Issue Escalation ensures</div>
                    <ul className="popover-list">
                      <li>Tiered escalation to specialists</li>
                      <li>Defined priority and severity handling</li>
                      <li>Vendor and OEM coordination</li>
                      <li>Executive communication on P1</li>
                      <li>Clear ETAs and action plans</li>
                      <li>Root cause analysis and closure</li>
                    </ul>
                  </div>
                  <p>Structured process for rapid resolution of critical issues.</p>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Support Benefits</h2>
                <ul className="benefits-list">
                  <li>✓ Average response time under 15 minutes</li>
                  <li>✓ Multi-channel support (phone, email, chat)</li>
                  <li>✓ Experienced technical professionals</li>
                  <li>✓ Comprehensive issue tracking</li>
                  <li>✓ Proactive monitoring and alerts</li>
                  <li>✓ Knowledge base and self-service options</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Response Time:</span>
                  <span className="highlight-value">&lt; 15 mins</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Availability:</span>
                  <span className="highlight-value">8 X 6/365</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Channels:</span>
                  <span className="highlight-value">Multi</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Resolution:</span>
                  <span className="highlight-value">99% Same Day</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default TechnicalSupport;
